import React, { FC } from "react"

const MoreIcon: FC = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26">
      <path
        d="M13.0001 14.0832C13.5984 14.0832 14.0834 13.5981 14.0834 12.9998C14.0834 12.4015 13.5984 11.9165 13.0001 11.9165C12.4018 11.9165 11.9167 12.4015 11.9167 12.9998C11.9167 13.5981 12.4018 14.0832 13.0001 14.0832Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5833 14.0832C21.1816 14.0832 21.6667 13.5981 21.6667 12.9998C21.6667 12.4015 21.1816 11.9165 20.5833 11.9165C19.985 11.9165 19.5 12.4015 19.5 12.9998C19.5 13.5981 19.985 14.0832 20.5833 14.0832Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.41659 14.0832C6.01489 14.0832 6.49992 13.5981 6.49992 12.9998C6.49992 12.4015 6.01489 11.9165 5.41659 11.9165C4.81828 11.9165 4.33325 12.4015 4.33325 12.9998C4.33325 13.5981 4.81828 14.0832 5.41659 14.0832Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default MoreIcon
